// extracted by mini-css-extract-plugin
export default {"toastGuestWarning":"toastGuestWarning_Lq_ItmqT"};